<template>
  <div v-redirect-if-no-permission:MONITORING style="width: 100%; height: 100%">
    <v-layout row>
      <v-flex>
        <v-chip v-for="(count, index) in counts" :color="count.color" :text-color="count.textColor" class="chips"
          v-if="index !== 'UNAVAILABLE'" @click="capFilter(index)">{{ index }} ({{ count.count }})
        </v-chip>
      </v-flex>

      <v-text-field v-model="searchQuery" solo dense :label="$t('common.search')" class="my-input"
        @input="testFunction"></v-text-field>
    </v-layout>
    <gmap-map ref="mapRef" :center="{ lat: 43.7313, lng: 7.4246 }" :zoom="14" :options="options" class="gmap">
      <gmap-marker v-for="(cap, index) in test" :key="cap.id" :position="{ lat: cap.lat, lng: cap.lng }"
        :clickable="true" :draggable="false" alignment="top"
        :icon="{ url: formSvg(cap.username, cap.icon), scaledSize: { width: 50, height: 35 } }">
      </gmap-marker>
    </gmap-map>
    <v-dialog v-model="dialog" hide-overlay persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          {{ $t("maps.captainsMap.pleaseStandBy") }}
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <div class="stations-div">
      <v-card class="all-stations">
        <div>
          <v-container>
            <v-layout wrap>

              <v-flex md4 sm12>
                <v-select class="vehicle-select filter-v-select" multiple chips :items="vehicle_types"
                  v-model="vehicle_type" :label="$t('maps.captainsMap.vehicleType')"></v-select>
              </v-flex>
              <v-flex md4 sm12>
                <v-select class="driver-select filter-v-select" multiple chips :items="captainTypes"
                  v-model="captain_type" :label="$t('maps.captainsMap.driverType')"></v-select>
              </v-flex>
              <v-flex md4 sm12>
                <div class="filter-submit-container">
                  <button class="filter-submit" @click="getCaptains" outline>{{ $t("common.submit") }}</button>
                </div>

              </v-flex>
            </v-layout>
          </v-container>
        </div>
        <!--
        <div>
          <v-select class="stations-select"  solo flat v-model="active_station" label="Drivers in" :items="stations_names" dense
            @change="testy"></v-select>
        </div>
        -->
        <div class="captains-list">
          <div class="captain" v-for="(captain, index) in active_captains">
            <img :src="api.GET_IMAGE(captain.profile_picture)" />
            <div class="name">
              {{ captain.first_name }}
              {{ captain.last_name }}
            </div>
            <div class="queue">#{{ index + 1 }}</div>
          </div>
        </div>

      </v-card>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import socketEventsMixin from "@/mixins/socketEventsMixin.js";
import api from "@/constants/api.js";

const clamp = (num, min, max) => Math.min(Math.max(num, min), max);

export default {
  mixins: [socketEventsMixin],
  events() {
    return {
      captain_location_updated: this.updateLocations,
      "Timeline:captain_check": this.updateStatuses,
    };
  },
  data() {
    const options = {
      mapTypeId: "roadmap",
      disableDefaultUI: true,
      zoomControl: false,
      mapTypeControl: false,
      scaleControl: false,
      streetViewControl: false,
      rotateControl: false,
      fullscreenControl: false,
      styles: [
        {
          featureType: "administrative",
          elementType: "labels.text.fill",
          stylers: [
            {
              color: "#a3a4ae",
            },
          ],
        },
        {
          featureType: "landscape",
          elementType: "all",
          stylers: [
            {
              color: "#e6eaf0",
            },
          ],
        },
        {
          featureType: "poi",
          elementType: "all",
          stylers: [
            {
              visibility: "simplified",
            },
          ],
        },
        {
          featureType: "poi",
          elementType: "labels.text",
          stylers: [
            {
              visibility: "simplified",
            },
            {
              gamma: "2",
            },
            {
              lightness: "3",
            },
            {
              color: "#778494",
            },
          ],
        },
        {
          featureType: "poi",
          elementType: "labels.icon",
          stylers: [
            {
              color: "#788E98",
            },
          ],
        },
        {
          featureType: "poi.attraction",
          elementType: "geometry.fill",
          stylers: [
            {
              visibility: "off",
            },
          ],
        },
        {
          featureType: "poi.park",
          elementType: "geometry.fill",
          stylers: [
            {
              visibility: "on",
            },
            {
              color: "#ceead6",
            },
          ],
        },
        {
          featureType: "poi.park",
          elementType: "labels.text.fill",
          stylers: [
            {
              color: "#39b65c",
            },
          ],
        },
        {
          featureType: "road",
          elementType: "labels",
          stylers: [
            {
              saturation: "0",
            },
            {
              lightness: "35",
            },
            {
              visibility: "simplified",
            },
            {
              gamma: "1",
            },
          ],
        },
        {
          featureType: "road.highway",
          elementType: "all",
          stylers: [
            {
              visibility: "simplified",
            },
          ],
        },
        {
          featureType: "road.highway",
          elementType: "geometry.fill",
          stylers: [
            {
              color: "#fde293",
            },
          ],
        },
        {
          featureType: "road.arterial",
          elementType: "labels.icon",
          stylers: [
            {
              visibility: "off",
            },
            {
              saturation: "-50",
            },
            {
              lightness: "17",
            },
          ],
        },
        {
          featureType: "transit",
          elementType: "all",
          stylers: [
            {
              visibility: "off",
            },
          ],
        },
        {
          featureType: "water",
          elementType: "all",
          stylers: [
            {
              color: "#8fbaff",
            },
            {
              visibility: "on",
            },
          ],
        },
      ],
    };
    return {
      sheet: false,
      dialog: false,
      open: false,
      allStations: [],
      allStationsData: [],
      stations_names: [],
      active_station: "",
      captain_type: [],
      vehicle_type: [],
      vehicle_types: [],
      active_captains: [],
      options,
      colors: {
        UNAVAILABLE: "#464A5A",
        BUSY: "#E10015",
        IN_STATION: "#FFEB3B",
        FREE: "#2EB7B7",
        AT_DESTINATION: "#E10015",
      },
      counts: {
        BUSY: {
          color: "#E10015",
          count: 0,
          textColor: "white"
        },
        IN_STATION: {
          color: "#FFEB3B",
          count: 0,
          textColor: "black"
        },
        FREE: {
          color: "#2EB7B7",
          count: 0,
          textColor: "white"
        },
        AT_DESTINATION: {
          color: "#E10015",
          count: 0,
          textColor: "white"
        },
      },
      searchQuery: null,
      search: false,
      map: null,
      test: [],
      allData: [],
      filteredResults: [],
      test2: [],
    };
  },
  computed: {
    captainTypes() {
      return [
        { text: this.$t("maps.captainsMap.normal"), value: "Normal" },
        { text: this.$t("maps.captainsMap.seasonal"), value: "Seasonal" },
      ];
    },
    resultQuery() {
      let i = 0;
      if (this.searchQuery && this.allData) {
        this.test = [];
        // console.log(this.allData);
        return Object.values(this.allData).filter((item) => {
          if (item.username || item.captain_status)
            if (item.username === this.searchQuery) {
              item.icon = item.captain_status;
              // item.lat = 43.7384 + i / 10; // add actual locations
              // item.lng = 7.4642; // add actual locations
              if (item.location) {
                item.lat = item.location.coordinates[1]; // add actual locations
                item.lng = item.location.coordinates[0]; // add actual locations
                // i++;
              }
              this.test.push(item);
              if (!(this.captain_type.length == 0 && this.vehicle_type.length == 0)) {
                this.test = this.test.filter(item2 =>
                  this.active_captains.some(item1 => item1.id === item2.id)
                )
              }
              return true;
            }
          // console.log(item);
          // this.filteredResults.push(item);
        });
        // console.log(this.filteredResults);
      } else {
        this.test = this.test2;
        if (!(this.captain_type.length == 0 && this.vehicle_type.length == 0)) {
          this.test = this.test.filter(item2 =>
            this.active_captains.some(item1 => item1.id === item2.id)
          )
        }
        // return this.locations;
      }
    },
  },
  methods: {
    getVehicleTypes() {
      this.axios
        .get("vehicle_type", {
          perPage: 100

        })
        .then((res) => {
          res.data.data.data.forEach((item) => {
            this.vehicle_types.push({
              text: item.name,
              value: item.id
            });
          });
        })
        .catch((err) => {
          let response = err.response;
          if (response) {
            window.getApp.$emit("SHOW_TOAST", response.data.message, "red");
          } else {
            window.getApp.$emit("SHOW_TOAST", this.$t("maps.captainsMap.vehicleTypesNotLoaded"), "red");
          }
        });
    },
    toggleInfoWindow(marker, idx) {
      this.show_booking_marker = true;
      if (marker.destinations) {
        this.pickup_marker = {
          lat: marker.destinations[0]
            ? marker.destinations[0].pick_up_location.coordinates[1]
            : 0,
          lng: marker.destinations[0]
            ? marker.destinations[0].pick_up_location.coordinates[0]
            : 0,
        };
      }
      this.dropoff_markers = marker.destinations;

      this.infoWindowPos = {
        lat: marker.location.coordinates[1],
        lng: marker.location.coordinates[0],
      };
      this.infoContent = this.getInfoWindowContent(marker);

      //check if its the same marker that was selected if yes toggle
      if (this.currentMidx == idx) {
        this.infoWinOpen = !this.infoWinOpen;
      }
      //if different marker set infowindow to open and reset current marker index
      else {
        this.infoWinOpen = true;
        this.currentMidx = idx;
      }
    },
    testy() {
      // let id = "";

      // for (let i = 0; i < this.allStationsData.length; i++) {
      // if (this.allStationsData[i].name === this.active_station) {
      // id = this.allStationsData[i].name;
      // console.log(this.active_station);
      // console.log(this.active_station.replace('Station ',''));
      // console.log('hiiii');
      // }
      // }
      // this.dialog = true;
      // let station = this.active_station.replace("Station ", "");
      // const url = this.api.ACTIONS.GET_STATION(station);
      // axios
      //   .get(url)
      //   .then((response) => {
      //     this.active_station_queue = response.data.data;
      //     console.log("active station queue");
      //     console.log(this.active_station_queue);
      //   })
      //   .finally(() => (this.dialog = false));
      // this.open = true;
    },
    getCaptains() {
      console.log(this.captain_type, this.vehicle_type)
      if (this.captain_type.length == 0 && this.vehicle_type.length == 0) {
        this.active_captains = [];
         this.test = this.test2;
         if (this.searchQuery) {
            this.testFunction();
          }
         return;
      }
      this.dialog = true;

      axios
        .post("stats/online-captains", {
          captain_type: this.captain_type,
          vehicle_type: this.vehicle_type
        })
        .then((response) => {
          this.active_captains = response.data.data;
          let tmp = this.test2;
          if (this.searchQuery) {
            this.testFunction();
            tmp = this.test;
          }

          this.test = tmp.filter(item2 =>
            this.active_captains.some(item1 => item1.id === item2.id)
          )

          console.log("active station queue");
          console.log(this.active_captains);
        })
        .finally(() => (this.dialog = false));
      // this.open = true;
    },
    formSvg(username, status) {
      return 'data:image/svg+xml;utf8,' + encodeURIComponent(`<?xml version='1.0' encoding='utf-8'?>
<svg version='1.1' id='pickup-pin' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px'
	 viewBox='0 0 57.5 41.4' style='enable-background:new 0 0 57.5 41.4;' xml:space='preserve'>
<g>
	<defs>
		<rect id='SVGID_1_' y='0' width='57.5' height='41.4'/>
	</defs>
	<clipPath id='SVGID_2_'>
		<use xlink:href='#SVGID_1_'  style='overflow:visible;'/>
	</clipPath>
	<g id='Mask_Group_6' style='clip-path:url(#SVGID_2_);'>
		<g id='Monaco_Pin_Active' transform='translate(0.259)'>
			<g id='Group_322' transform='translate(6.622 22.284)'>
				<path id='Path_374' style='fill:${this.counts[status].color};' d='M31.8,0l-9.9,19.1L11.9,0C17.9,4.2,25.9,4.2,31.8,0L31.8,0z'/>
			</g>
			<g id='Group_323' transform='translate(0)'>
				<path style='fill:${this.counts[status].color};' d='M4.8,31.8h47.3c2.8,0,5.1-2.3,5.1-5.1V5.1C57.3,2.3,55,0,52.2,0H4.8C2,0-0.3,2.3-0.3,5.1v21.7
					C-0.3,29.6,2,31.8,4.8,31.8z'/>
			</g>
		</g>
	</g>
</g>
<g>
	<text style=' font:medium 12pt; fill:${this.counts[status].textColor}; font-family: Poppins; text-align:center; alignment-baseline: middle;' x='13.5' y='18' id='taxiNumber'>${username.toString().padStart(3, '0')}</text>
</g>
</svg>`);
    },
    close() {
      this.open = false;
    },
    updateStatuses(captain_id, id, status, driver) {
      for (let i = 0; i < this.test.length; i++) {
        if (this.test[i].id == captain_id) {
          this.counts[this.test[i].icon].count--;
          if (this.counts[status]) this.counts[status].count++;
          if (status !== "UNAVAILABLE") this.test[i].icon = status;
          else this.test.splice(i, 1);

          break;
        }
        if (i === this.test.length - 1) {
          this.test.push({
            lat: 0,
            lng: 0,
            icon: status,
            fname: driver.first_name,
            lname: driver.last_name,
            id: captain_id,
          });
          this.counts[status].count++;
          break;
        }
      }
    },
    updateLocations(data) {
      for (let i = 0; i < this.test.length; i++) {
        if (this.test[i].id == data.captain_id) {
          this.test[i].lng = data.location.coordinates[0];
          this.test[i].lat = data.location.coordinates[1];
        }
      }
    },
    capFilter(value) {
      this.test = this.test2;
      let x = [];
      for (let i = 0; i < this.test.length; i++) {
        if (this.test[i].icon === value) {
          x.push(this.test[i]);
        }
      }
      this.test = [];
      this.test = x;
      // console.log(x);
    },

    testFunction() {
      console.log(this.resultQuery);
    },
  },
  mounted() {
    this.getVehicleTypes();
    axios.get(this.api.ACTIONS.ALL_STATIONS).then((response) => {
      // console.log(response.data.data.stations);
      // console.log("ss");

      this.allStationsData = response.data.data.stations;
      // console.log(this.allStations);
      for (let i = 0; i < this.allStationsData.length; i++) {
        // console.log("ss");
        let obj = {};
        // if (response.data[i].centroid) {
        obj = {
          // lat: response.data.data.stations[i].centroid.coordinates[0],
          // lng: response.data.data.stations[i].centroid.coordinates[1],
          id: response.data.data.stations[i].id,
          name: response.data.data.stations[i].name,
        };
        // }

        // console.log(obj);
        this.allStations.push(obj);
        this.stations_names.push(obj.name);
      }
      // console.log("edn");
      // if (this.allStations) console.log(this.allStations);
    });
    this.dialog = true;
    axios
      .get(this.api.ACTIONS.GET_ALL_CAPTAINS)
      .then((response) => {
        this.allData = response.data.data;

        for (let i = 0; i < Object.keys(this.allData).length; i++) {
          if (response.data.data[i].captain_status !== "UNAVAILABLE") {
            let obj = {
              lat: response.data.data[i].location
                ? response.data.data[i].location.coordinates[1]
                : 0,
              lng: response.data.data[i].location
                ? response.data.data[i].location.coordinates[0]
                : 0,
              icon: response.data.data[i].captain_status,
              fname: response.data.data[i].first_name,
              lname: response.data.data[i].last_name,
              id: response.data.data[i].id,
              username: response.data.data[i].username,
            };

            this.counts[response.data.data[i].captain_status].count++;

            // console.log(obj);
            this.test.push(obj);
            this.test2 = this.test.slice();

          }
        }
      })
      .finally(() => (this.dialog = false));
  },
};
</script>
<style lang="scss" scoped>
.gmap {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0px;
  left: 0px;
}

.my-input {
  z-index: 6;
  max-width: 300px;
  margin-top: 5px;
  margin-right: 5px;
}

.stations-div {
  padding: 24px 12px;
  bottom: 0;
  position: absolute;
  width: 40%;
}

// .my-input {
// .v-input__control {
//    .v-input__slot {

//      border-radius: 15px !important;
//    }
//   }
// }
// .my-input > .v-input__control > .v-input__slot {
//   border-radius: 15px;
// }
// .v-input__slot {
//   border-radius: 15px;
// }

.vue-map-hidden {
  display: block !important;
}

.driver-select {
  max-width: 275px;
  max-height: 46px;
  border-radius: 15px;
  margin-left: 50px;
  margin-top: 20px;
}

.vehicle-select {
  max-width: 275px;
  max-height: 46px;
  border-radius: 15px;
  margin-left: 50px;
  margin-top: 20px;
}

.filter-submit {
  background-color: rgb(225, 0, 21);
  border-radius: 15px;
  color: white;
  padding: 15px;
}

.filter-submit-container {
  z-index: 1;
  max-width: 275px;
  max-height: 46px;
  border-radius: 15px;
  margin-left: 50px;
  margin-top: 20px;
}

.stations-select {
  z-index: 1;
  max-width: 275px;
  max-height: 46px;
  border-radius: 15px;
  margin-left: 5px;
  margin-top: 5px;

  &:before {
    float: left;
    width: 130px;
    display: inline;
    margin-top: 11px;
    content: "Drivers in";
    font-size: 12pt;
    margin-left: 10px;
  }
}

.chips {
  z-index: 1;
}

.v-chip:hover * {
  cursor: pointer !important;
}

.slidein {
  max-height: 200px;
  padding: 2em 3em;
  position: fixed;
  z-index: 100;
  right: 0;
  bottom: 0;
  left: 0;
  background: white;
  height: 100%;
  box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.5);
  transition: all 0.5s ease-in-out;
  display: flex !important;
  flex-direction: column;
  overflow-y: scroll;
}

/* before the element is shown, start off the screen to the right */
.slide-enter,
.slide-leave-active {
  bottom: -100%;
}

.close-btn {
  border: none;
  font-weight: bold;
  font-size: 2em;
  background: transparent;
  position: absolute;
  top: 0;
  right: 0;
  padding: 0.5em;
}

/* General styles unrelated to slide in */
body {
  font-family: "Mulish", sans-serif;
}

.toggle {
  margin: 1em;
}

.v-card {
  display: flex !important;
  flex-direction: column;
}

.scrl {
  display: flex !important;

  overflow-y: scroll;
}

.v-card__text {
  flex-grow: 1;
  overflow: auto;
}

.captains-list {
  width: 100%;
  max-height: 350px;
  min-height: 50px;
  float: left;
  padding: 22px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
  overflow-y: auto;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    border-radius: 10px;
    background-color: #ededed;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: #788e98;
  }
}

.captain {
  width: 100%;
  float: left;
  font-size: 12pt;
  font-weight: normal !important;
  padding: 12px;
  box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.08);
  display: flex;
  align-items: center;
  gap: 12px;
  border-radius: 6px;

  img {
    height: 32px;
    width: 32px;
    float: left;
    border-radius: 100%;
  }

  .name {
    color: #202731;
    width: max-content;
    overflow: hidden;
    min-width: 140px;
    max-width: 250px;
  }

  .queue {
    color: #788e98;
  }
}

.all-stations {
  height: auto;
  max-height: 350px;
  width: 100%;
  border-radius: 10px;
  height: max-content;
  bottom: 0;
  overflow: auto;
}

.filter-v-select {
  margin-bottom: 20px;
  height: auto;
}

.station {
  bottom: 1px;
  max-height: 160px;
  min-height: 150px;
  width: 1400px;
  border-radius: 15px;
  margin-left: 50px;
  height: max-content;
  position: absolute;
}
</style>
